import React, { useState } from 'react';
import { Modal, Form, Input, Upload, Button, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';

const { TextArea } = Input;

interface PaymentProofModalProps {
  visible: boolean;
  onCancel: () => void;
  onSubmit: (paymentNote: string, file: any) => void;
  loading?: boolean;
}

export const PaymentProofModal: React.FC<PaymentProofModalProps> = ({
  visible,
  onCancel,
  onSubmit,
  loading = false,
}) => {
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState<any[]>([]);

  React.useEffect(() => {
    if (visible) {
      form.resetFields();
      setFileList([]);
    }
  }, [visible, form]);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      onSubmit(values.paymentNote, fileList[0] || null);
    } catch (err) {
      // Form validation error
    }
  };

  const uploadProps = {
    onRemove: () => setFileList([]),
    beforeUpload: (file: any) => {
      setFileList([file]);
      return false;
    },
    fileList,
  };

  return (
    <Modal
      title="Xác nhận Thanh toán & Upload Ủy nhiệm chi (UNC)"
      visible={visible}
      onOk={handleOk}
      onCancel={onCancel}
      confirmLoading={loading}
      okText="Xác nhận Đã Thanh Toán"
      cancelText="Hủy"
      destroyOnClose
    >
      <Form form={form} layout="vertical">
        <Form.Item name="paymentNote" label="Ghi chú thanh toán">
          <TextArea rows={3} placeholder="Ví dụ: Đã chuyển khoản qua VCB lúc 14:30..." />
        </Form.Item>

        <Form.Item label="Ủy nhiệm chi (UNC) / Chứng từ chuyển khoản">
          <Upload {...uploadProps} maxCount={1}>
            <Button icon={<UploadOutlined />}>Tải lên file UNC (PDF, PNG, JPG)</Button>
          </Upload>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default PaymentProofModal;
